export const BST_CENSUS_MISMATCHES = {
    NO_BST: 'No BroadStreet record available',
    BST_FACILITY_MISMATCH: 'BroadStreet Facility mismatch',
    BST_CENSUS_MISMATCH: 'BroadStreet Census Status mismatch',
    BST_LOC_MISSING: 'BroadStreet Level of Care missing',
    BST_LOC_MISMATCH: 'BroadStreet Level of Care mismatch',
};
